import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'titleCase',
})
export class TitleCasePipe implements PipeTransform {

	transform(value: string | null | undefined): string | null {

		if (!value) {

			return null;
		}

		return value
			.toLowerCase()
			.split(' ')
			.filter((word) => word.length > 0)
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	}
}
